// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { addListener, removeListener } from "~/lib/signals";
import { deferPromise } from "~/util/general";
import { CONFIG } from "~/config";

const HEIGHT = "265px";
export default class Map extends Content {
	destroy() {
		this._api.$destructor();
		this._api = null;
		removeListener(this._resizeId);
		super.destroy();
	}

	getPosterData() {
		return this._promiseData.promise;
	}

	_build() {
		this._dom.container.classList.add("content-map");
		this._dom.container.style.width = "100%";
		this._dom.container.style.height = HEIGHT;

		this._dom.container.style.cssTxt = "visibility:hidden; position:absolute; top:-1000px; left:-1000px";
		/* musime vlozit do detailu a ne do document.body, aby sirka 100% byla spravna +/-, protoze scrollbar nasledne, ale porad to sedi dobre */
		var detail = document.querySelector("#detail");
		if (detail) {
			detail.appendChild(this._dom.container);
		}

		var center = SMap.Coords.fromWGS84(this._data.center.x, this._data.center.y);
		this._api = new SMap(this._dom.container, center, 14);
		if (this._data.source === "bs") {
			let tiles = new SMap.Layer.Tile("winter", `${CONFIG.mapserver.url}/winter-m/`);
			this._api.addLayer(tiles).enable();
		} else {
			this._api.addDefaultLayer(SMap.DEF_BASE).enable();
		}

		while (this._api.getControls().length) {
			this._api.removeControl(this._api.getControls()[0]);
		}

		var layer = new SMap.Layer.Marker();
		this._api.addLayer(layer);
		layer.enable();

		this._dom.container.style.visibility = "visible";
		this._dom.container.style.position = "relative";

		var mark = this._buildMark();
		layer.addMarker(mark);

		this._promiseData = deferPromise();
		this._promiseData.resolve([this._dom.container, "map"]);

		this._api.syncPort();

		this._resizeId = addListener(this, "resize", () => {
			this._api.syncPort();
		});
	}

	_buildMark() {
		var coords = this._api.getCenter();

		return new SMap.WMMarker(coords);
	}
}
